var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-results" },
    [
      _c("search-filter", {
        attrs: { categories: _vm.categories, searchTerm: _vm.searchTerm },
        on: {
          "update:searchTerm": function($event) {
            _vm.searchTerm = $event
          },
          "update:search-term": function($event) {
            _vm.searchTerm = $event
          },
          formSearch: _vm.submitSearch
        }
      }),
      _vm._v(" "),
      !_vm.initialLoad
        ? _c("div", { staticClass: "grid-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid-x grid-margin-x o-columns__two o-columns__two--alt-1"
              },
              [
                _c(
                  "div",
                  { staticClass: "cell", attrs: { "aria-live": "polite" } },
                  [
                    _c("p", { staticClass: "c-summary" }, [
                      _vm._v(
                        'You searched for "' +
                          _vm._s(_vm.searchTerm) +
                          '", we have found ' +
                          _vm._s(_vm.totalResultsCount) +
                          " results."
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell" },
                  [
                    _c(
                      "search-tablist",
                      [
                        _c(
                          "search-tab",
                          {
                            attrs: {
                              name: "searchResultsPages",
                              panelSuffix: "Panel",
                              tabSuffix: "Tab",
                              isActive: true,
                              title: "Pages"
                            }
                          },
                          [
                            _vm.hasPageResults
                              ? _c("search-listing", {
                                  attrs: {
                                    "item-component": "SearchItemPage",
                                    resultsListing: _vm.pageResults
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasPageResults
                              ? _c("search-paging", {
                                  attrs: {
                                    searchType: "pages",
                                    currentPage: _vm.pageCurrentPage,
                                    totalPages: _vm.pageTotalPages
                                  },
                                  on: { getResults: _vm.getSearchResults }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.pageResultsError
                              ? _c("search-error")
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.hasPageResults && !_vm.pageResultsError
                              ? _c("search-no-results", {
                                  attrs: {
                                    searchType: "pages",
                                    searchTerm: _vm.searchTerm
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "search-tab",
                          {
                            attrs: {
                              name: "searchResultsDocuments",
                              panelSuffix: "Panel",
                              tabSuffix: "Tab",
                              isActive: false,
                              title: "Documents"
                            }
                          },
                          [
                            _vm.hasDocResults
                              ? _c("search-listing", {
                                  attrs: {
                                    "item-component": "SearchItemDoc",
                                    resultsListing: _vm.docResults
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasDocResults
                              ? _c("search-paging", {
                                  attrs: {
                                    searchType: "documents",
                                    currentPage: _vm.docCurrentPage,
                                    totalPages: _vm.docTotalPages
                                  },
                                  on: { getResults: _vm.getSearchResults }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.docResultsError ? _c("search-error") : _vm._e(),
                            _vm._v(" "),
                            !_vm.hasDocResults && !_vm.docResultsError
                              ? _c("search-no-results", {
                                  attrs: {
                                    searchType: "documents",
                                    searchTerm: _vm.searchTerm
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("search-loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-070dcd4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070dcd4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/partnerhub/results/SearchResults.vue
// module id = 560
// module chunks = 0